import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

// Upload/removal of the professional's A1 digital certificate (stored in the bucket by the quarkus backend).
export function useProfessionalDigitalCertificate() {
  const [isSending, setSending] = useState(false);

  const upload = useCallback((professionalId, file) => {
    setSending(true);
    const formData = new FormData();
    formData.append('file', file);
    return quarkusApi
      .post(`/dentista/${professionalId}/digital-certificate`, formData, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSending(false));
  }, []);

  const remove = useCallback((professionalId) => {
    setSending(true);
    return quarkusApi
      .delete(`/dentista/${professionalId}/digital-certificate`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSending(false));
  }, []);

  return { upload, remove, isSending };
}
